import { ILabelsSettingValues } from '~/pages/Settings/Labels/types';
import { ActionKeys } from './constants';

export function fetchLabelSettings() {
  return <const>{
    type: ActionKeys.FETCH_LABEL_SETTINGS,
  };
}

export function submitLabelsForm(formData: ILabelsSettingValues) {
  return <const>{
    type: ActionKeys.SAVE_LABEL_SETTINGS,
    payload: {
      formData,
    },
  };
}

// TODO: Name is not standard. Rename
export function didSaveLabel(response) {
  return <const>{
    type: ActionKeys.SAVE_LABEL_SETTINGS_SUCCESS,
    payload: response,
  };
}

export function fetchLabelSettingsSuccess(response) {
  return <const>{
    type: ActionKeys.FETCH_LABEL_SETTINGS_SUCCESS,
    payload: response,
  };
}

export function fetchPreviewLink(labelLogoType) {
  return <const>{
    type: ActionKeys.FETCH_LABEL_PREVIEW_LINK,
    payload: { labelLogoType },
  };
}

export type LabelsSettingsActions =
  | ReturnType<typeof fetchLabelSettings>
  | ReturnType<typeof submitLabelsForm>
  | ReturnType<typeof didSaveLabel>
  | ReturnType<typeof fetchLabelSettingsSuccess>
  | ReturnType<typeof fetchPreviewLink>;
